import { render, staticRenderFns } from "./entrust.vue?vue&type=template&id=ffd9f22e&scoped=true&"
import script from "./entrust.vue?vue&type=script&lang=js&"
export * from "./entrust.vue?vue&type=script&lang=js&"
import style0 from "./entrust.vue?vue&type=style&index=0&id=ffd9f22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd9f22e",
  null
  
)

export default component.exports